<template>
    <AuthLayout show-legal>

        <template v-if="!$page.props.user">
            <!-- Nadpis -->
            <div>
                <h2 class="text-2xl font-bold text-gray-900 dark:text-neutral-200">Přihlaste se do účtu</h2>
                <p class="mt-1 text-sm text-gray-500 dark:text-neutral-200">
                    Nemáte účet?
                    <span @click="router.visit('/register', { preserveState: true })"
                          class="text-blue-600 dark:text-blue-400 hover:underline cursor-pointer font-medium">
                            Získejte Roori zdarma
                        </span>
                </p>
            </div>

            <!-- Sociální loginy -->
            <div class="flex gap-3 pt-4">
                <Button @click="thirdPartyLogin('google')" size="large" outlined severity="secondary"
                        class="flex-1 h-18 ">
                    <google-icon class="w-5 h-5 mr-2"/>
                    Google
                </Button>
                <Button @click="thirdPartyLogin('microsoft')" size="large" outlined severity="secondary"
                        class="flex-1 h-18" icon="pi pi-microsoft" label="Microsoft"/>
                <Button @click="thirdPartyLogin('maeum')" size="large" outlined severity="secondary"
                        class="flex-1 h-18">
                    MAEUM
                </Button>
            </div>

            <!-- Oddělovač -->
            <div class="flex items-center gap-4 my-4">
                <hr class="flex-grow border-gray-300 dark:border-neutral-700"/>
                <span class="text-gray-400 text-sm">nebo pokračujte emailem</span>
                <hr class="flex-grow border-gray-300 dark:border-neutral-700"/>
            </div>

            <!-- Formulář -->
            <div class="space-y-4" @keyup.enter="form.submit">
                <InputText id="email" placeholder="E-mail" autocomplete="email" type="email"
                           class="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-700 placeholder-gray-400 focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                           v-model="form.email"
                           :invalid="form.errors['email']"/>
                <small v-if="form.invalid('email')"
                       class="text-red-500 -mt-2">{{ form.errors['email'] }}</small>
                <InputText id="password" placeholder="Heslo" type="password" autocomplete="current-password"
                           class="w-full rounded-md border border-gray-300 px-4 py-2 text-gray-700 placeholder-gray-400 focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                           v-model="form.password"
                           :invalid="form.invalid('password')"/>
                <small v-if="form.errors['password']"
                       class="text-red-500 -mt-2">{{ form.errors['password'] }}</small>

                <Button label="Přihlásit se" :loading="form.processing" @click="form.submit"
                        class="w-full"></Button>
            </div>
        </template>
        <div v-else @keyup.enter="router.visit('/app')">
            <!-- Nadpis a přivítání -->
            <div>
                <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Vítejte zpět</h2>
                <p class="mt-1 text-sm text-gray-500 dark:text-neutral-200">
                    Pokračujte do svého účtu nebo se odhlaste
                </p>
            </div>
            <!-- Akční tlačítka -->
            <div class="space-y-4 mt-6">
                <Button type="button"
                        @click="router.visit('/app')"
                        severity="primary"
                        icon="pi pi-user"
                        class="w-full"
                        :label="'Pokračovat jako ' + $page.props.user?.name"
                        :badge="$page.props.initials">
                </Button>
                <div class="flex items-center gap-4 my-4">
                    <hr class="flex-grow border-gray-300 dark:border-neutral-700"/>
                    <span class="text-gray-400 text-sm">nebo</span>
                    <hr class="flex-grow border-gray-300 dark:border-neutral-700"/>
                </div>
                <Button type="button"
                        outlined
                        severity="secondary"
                        @click="router.visit('/logout')"
                        icon="pi pi-sign-out"
                        class="w-full"
                        label="Odhlásit se">
                </Button>
            </div>
        </div>

    </AuthLayout>
</template>
<script setup>
import Button from 'primevue/button';
import Divider from 'primevue/divider';
import InputText from 'primevue/inputtext';
import AuthLayout from '../components/view-components/AuthLayout.vue';

import Avatar from 'primevue/avatar';

import {
    computed, inject, onBeforeMount,
    ref
} from 'vue';
import {
    useToast
} from 'primevue/usetoast';
import {router, usePage} from "@inertiajs/vue3";
import {useForm} from "laravel-precognition-vue-inertia";
import GoogleIcon from "../components/GoogleIcon.vue";
import LoginBlogPost from "../../administration/components/ui-components/LoginBlogPost.vue";

const isLoading = ref(true)
const articles = ref([])
const parnassusUrl = usePage().props.olympus.parnassus_url;

const thirdPartyLogin = (provider) => {
    window.location.href = `/login/${provider}`;
}

const form = useForm('post', '/login-action', {
    email: '',
    password: ''
})

onBeforeMount(() => {
    const endpoint = `blog`;
    axios.get(parnassusUrl + endpoint, {}).then(response => {
        articles.value = response.data;
        isLoading.value = false;
    })
});


</script>
<style lang="scss" scoped>
.login-view {
    transform: scale(0.9);
    pointer-events: none;
    opacity: 0;
    transition: all .3s ease-in-out;
}

.active {
    bottom: 0;
    pointer-events: all;
    opacity: 1;
    transform: scale(1);
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.height-fade-enter-active,
.height-fade-leave-active {
    transition: all 0.3s ease;
}

.height-fade-enter-from,
.height-fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
</style>
